import { Button, Popover } from "@mui/material";
import CalendarToday from "@mui/icons-material/CalendarToday";
import { useRef, useState } from "react";
import { shortDate } from "../../../misc/dates";
import { panelWidth, PickDate } from "../panel/PickDate";

// BulkDueDateButton picks the due date the selected tasks are moved to. undefined is
// no change, and null takes the due date off.
export function BulkDueDateButton(props: {
    value: string | null | undefined;
    onChange: (value: string | null) => void;
}) {
    const anchor = useRef<HTMLButtonElement>(null);
    const [open, setOpen] = useState(false);

    let label = "No change";
    if (props.value === null) label = "No due date";
    else if (props.value) label = shortDate(props.value);

    return (
        <>
            <Button
                ref={anchor}
                size="small"
                color={props.value === undefined ? "inherit" : "primary"}
                startIcon={<CalendarToday fontSize="inherit" />}
                sx={{
                    borderRadius: 5, borderStyle: props.value === undefined ? "dashed" : "solid",
                    textTransform: "none", fontSize: 12, minWidth: 0, py: 0.125, px: 1,
                    "& .MuiButton-startIcon": { mr: 0.5 },
                }}
                onClick={() => setOpen(true)}
            >
                {label}
            </Button>

            <Popover
                open={open}
                anchorEl={anchor.current}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <div style={{ width: panelWidth, paddingBottom: 8 }}>
                    <PickDate
                        value={props.value || ""}
                        onChange={value => {
                            props.onChange(value);
                            setOpen(false);
                        }}
                        onClear={() => {
                            props.onChange(null);
                            setOpen(false);
                        }}
                    />
                </div>
            </Popover>
        </>
    );
}
